import React from 'react'
import styles from './columnsGrid.module.scss'

export const ContentGrid = ({ children }) => (
  <div className={styles.content}>{children}</div>
)

export const AsideGrid = ({ children }) => (
  <aside className={styles.aside}>{children}</aside>
)

export const ColumnsGrid = ({ children }) => (
  <div className={styles.grid}>{children}</div>
)
